export default "__VITE_ASSET__zhURH3zK__"